export default {"src":"/_next/static/media/secured-by-shopify.cd20b96d.svg","height":19,"width":131,"blurWidth":0,"blurHeight":0};